export type Episode = {
  id: string;
  no: number;
  title: string;
  tag: string;
  duration: string;
  summary: string;
  hot: boolean;
};

export const siteName = '欲望的诱惑';

export const heroStats = [
  { value: '90', unit: '集', label: '全集剧集' },
  { value: '2', unit: '分钟', label: '单集时长' },
  { value: '都市', unit: '情感', label: '题材类型' },
  { value: '5', unit: '大', label: '看点分区' },
];

export const updateStrip = [
  '更新条 · 第 81–90 集已上线，全集免费浏览',
  '短剧大合集 · 按标签筛选你感兴趣的剧集脉络',
  '全部剧集索引已整理，可逐段浏览完整剧情',
  '名场面与看点单独成区，跳转更快',
];

export const synopsisParagraphs = [
  '《欲望的诱惑》是一部围绕都市情感与人性博弈展开的短剧：当一段看似偶然的相遇被层层算计包裹，欲望与真心之间的界线开始变得模糊，每个角色都在利益与情感之间做出自己的选择。',
  '剧集以紧凑的短剧节奏推进，几乎每一集都会抛出新的线索与反转，让观众在碎片化的时间里也能获得完整的情绪起伏。它并不急于给出答案，而是把人物的动机一点点摊开在观众面前。',
  '本页按剧集、看点、角色、名场面与追剧指南分区整理，方便你根据自己的关注点，快速定位想看的全部剧集与完整短剧脉络。',
];

export const themes = [
  {
    icon: 'ri-refresh-line',
    title: '层层反转结构',
    desc: '剧情以高频反转推进，前半段的线索往往在后半段被重新解释，适合喜欢被剧情反复“翻盘”的观众。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '都市情感张力',
    desc: '把职场、家庭与爱情放在同一条时间线上，人物在关系拉扯中逐渐显露真实的一面。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '短剧节奏轻快',
    desc: '单集时长控制在两分钟左右，通勤、午休等碎片时间即可推进多集，全集连看也不会觉得拖沓。',
  },
  {
    icon: 'ri-group-line',
    title: '人物关系博弈',
    desc: '每个角色都有自己的目的，表面合作、暗中较劲，人物之间的权力与情感此消彼长。',
  },
  {
    icon: 'ri-camera-lens-line',
    title: '电影级氛围感',
    desc: '偏冷的夜幕影调搭配暖金高光，画面强调光影对比，让情绪在沉默镜头里被放大。',
  },
  {
    icon: 'ri-discuss-line',
    title: '开放式结局讨论',
    desc: '结局留出解读空间，不同观众对“谁赢了、谁输了”往往有完全不同的答案。',
  },
];

export const episodeTags = ['全部', '情感', '悬疑', '反转', '高能', '结局'];

export const episodes: Episode[] = [
  { id: 'ep01', no: 1, title: '初遇 · 雨里的伞', tag: '情感', duration: '02:10', hot: false, summary: '一场突如其来的雨，让两个本不该有交集的人在同一个屋顶下短暂停留，埋下后续所有纠葛的起点。' },
  { id: 'ep02', no: 2, title: '误会 · 未接来电', tag: '情感', duration: '02:04', hot: false, summary: '一通没有接起的电话，让两人对彼此的第一印象走向完全相反的方向，也为后面的试探写下伏笔。' },
  { id: 'ep03', no: 3, title: '契约 · 各取所需', tag: '反转', duration: '02:18', hot: true, summary: '为了各自的理由，两人达成一份不对外的合作约定，看似公平的条款背后藏着只有一方知道的秘密。' },
  { id: 'ep04', no: 4, title: '夜晚 · 试探', tag: '悬疑', duration: '02:05', hot: false, summary: '一次看似随意的晚宴，桌面上是寒暄，桌面下是互相打探，谁先露出破绽谁就失去主动。' },
  { id: 'ep05', no: 5, title: '身份 · 疑云', tag: '悬疑', duration: '02:12', hot: false, summary: '一个被刻意淡化的旧身份浮出水面，让原本清晰的立场开始摇晃，信任出现第一道裂痕。' },
  { id: 'ep06', no: 6, title: '旧人 · 重逢', tag: '情感', duration: '02:07', hot: false, summary: '多年未见的人重新出现，把两人之间刚刚建立的默契重新推回原点，情绪暗流再次涌动。' },
  { id: 'ep07', no: 7, title: '针锋 · 相对', tag: '高能', duration: '02:20', hot: true, summary: '积累的怀疑终于被摆上台面，一场正面对峙让双方都放下了伪装，也撕开了更大的谜团。' },
  { id: 'ep08', no: 8, title: '密约 · 暗手', tag: '反转', duration: '02:09', hot: false, summary: '一份没有署名的文件被交换，谁是执棋者谁是棋子，在这一集里给出了不同的答案。' },
  { id: 'ep09', no: 9, title: '真心 · 假意', tag: '情感', duration: '02:15', hot: false, summary: '当日常的照顾不再像表演，两人开始分不清此刻的靠近，到底是算计还是习惯。' },
  { id: 'ep10', no: 10, title: '背叛 · 当众', tag: '高能', duration: '02:22', hot: true, summary: '一次公开场合的揭穿让局面彻底失控，原本平衡的关系被打破，被迫进入新的选择。' },
  { id: 'ep11', no: 11, title: '证据 · 浮现', tag: '悬疑', duration: '02:11', hot: false, summary: '被忽略的细节重新被拼起来，过去的疑点逐一得到解释，也指向一个更意想不到的方向。' },
  { id: 'ep12', no: 12, title: '绝地 · 反击', tag: '高能', duration: '02:25', hot: true, summary: '退无可退的一方开始反击，用对方最熟悉的方式把局势反转，全剧情绪达到高点。' },
  { id: 'ep13', no: 13, title: '真相 · 前夕', tag: '反转', duration: '02:08', hot: false, summary: '所有线索在即将揭晓前再一次被推翻，观众和剧中人同时发现，最初的判断可能一直是错的。' },
  { id: 'ep14', no: 14, title: '摊牌 · 之夜', tag: '高能', duration: '02:26', hot: true, summary: '所有伪装在同一晚被卸下，人物把压了很久的话一次说完，关系迎来不可能回头的转折。' },
  { id: 'ep15', no: 15, title: '尘埃 · 落定', tag: '结局', duration: '02:30', hot: false, summary: '算计与情感各自得到结算，有人得偿所愿，也有人付出代价，故事走向收束。' },
  { id: 'ep16', no: 16, title: '迟到的告白', tag: '结局', duration: '02:33', hot: true, summary: '在一切归于平静之后，一句迟到的告白给出了另一种解读，也让开放式结局留下来回回味。' },
];

export const characters = [
  {
    name: '沈知夏',
    role: '女主角',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20portrait%20of%20a%20composed%20Chinese%20woman%20in%20elegant%20modern%20office%20attire%2C%20calm%20determined%20expression%2C%20crimson%20and%20gold%20cinematic%20lighting%2C%20dark%20textured%20studio%20background%2C%20high%20contrast%20shadows%2C%20soft%20film%20grain%2C%20luxury%20short%20drama%20poster%20style&width=600&height=800&seq=char-shenzhixia&orientation=portrait',
    desc: '冷静克制的职场人，习惯先观察再行动，一旦决定就不再回头，是全局情绪最稳定的支点。',
  },
  {
    name: '陆修远',
    role: '男主角',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20portrait%20of%20a%20confident%20Chinese%20man%20in%20a%20dark%20tailored%20suit%2C%20serious%20magnetic%20gaze%2C%20crimson%20and%20warm%20gold%20cinematic%20lighting%2C%20dark%20elegant%20background%2C%20high%20contrast%20shadows%2C%20film%20grain%2C%20luxury%20short%20drama%20poster%20style&width=600&height=800&seq=char-luxiuyuan&orientation=portrait',
    desc: '强势而深情的继承者，习惯把真实想法藏在行动里，越靠近越让人分不清他的真心与算计。',
  },
  {
    name: '顾漫宁',
    role: '关键配角',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20portrait%20of%20a%20stylish%20Chinese%20woman%20with%20subtle%20sly%20smile%2C%20designer%20fashion%2C%20deep%20red%20and%20gold%20cinematic%20lighting%2C%20dark%20textured%20studio%20backdrop%2C%20dramatic%20shadows%2C%20film%20grain%2C%20short%20drama%20poster%20style&width=600&height=800&seq=char-gumannning&orientation=portrait',
    desc: '表面亲和的“知己”，每一次关心都精准踩在关键节点上，是推动关系失衡的重要变量。',
  },
  {
    name: '江辰',
    role: '关键配角',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20portrait%20of%20a%20gentle%20Chinese%20man%20in%20a%20knit%20sweater%2C%20soft%20outward%20warmth%20with%20hidden%20thought%2C%20crimson%20and%20amber%20cinematic%20lighting%2C%20dark%20muted%20background%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20short%20drama%20poster%20style&width=600&height=800&seq=char-jiangchen&orientation=portrait',
    desc: '温柔却藏着主见的旁观者，看似不问纷争，实则每一步都踩在对的时间点上。',
  },
  {
    name: '沈母',
    role: '长辈线',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20portrait%20of%20an%20elegant%20older%20Chinese%20woman%20with%20sharp%20shrewd%20eyes%2C%20refined%20dark%20clothing%2C%20deep%20crimson%20and%20gold%20cinematic%20lighting%2C%20dark%20textured%20background%2C%20dramatic%20shadow%2C%20film%20grain%2C%20short%20drama%20poster%20style&width=600&height=800&seq=char-shenmu&orientation=portrait',
    desc: '精明而现实的母亲，习惯用家族利益衡量一切，她的取舍往往决定了年轻人的退路。',
  },
  {
    name: '林亦',
    role: '反转支点',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20portrait%20of%20a%20young%20Chinese%20person%20with%20quiet%20watchful%20expression%2C%20minimal%20dark%20clothing%2C%20crimson%20and%20gold%20rim%20lighting%2C%20dark%20studio%20background%2C%20high%20contrast%2C%20film%20grain%2C%20luxury%20short%20drama%20poster%20style&width=600&height=800&seq=char-linyi&orientation=portrait',
    desc: '前期低调的“记录者”，在关键节点上提供让局势翻转的信息，是全部谜团的钥匙。',
  },
];

export const scenes = [
  {
    title: '雨夜对峙',
    ep: '第 7 集',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20rainy%20city%20street%20at%20night%20with%20glossy%20wet%20pavement%20reflecting%20crimson%20and%20gold%20neon%20lights%2C%20two%20distant%20silhouettes%20facing%20each%20other%2C%20moody%20dramatic%20atmosphere%2C%20film%20grain%2C%20short%20drama%20still&width=900&height=600&seq=scene-rainy-night&orientation=landscape',
    desc: '积压的怀疑第一次被摊开，雨声压过了所有解释，也是全剧节奏开始加速的转折镜头。',
  },
  {
    title: '天台告白',
    ep: '第 9 集',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20rooftop%20at%20dusk%20overlooking%20a%20glowing%20city%2C%20warm%20amber%20and%20deep%20crimson%20sky%2C%20two%20figures%20standing%20apart%20in%20silence%2C%20emotional%20cinematic%20mood%2C%20soft%20film%20grain%2C%20short%20drama%20still&width=900&height=600&seq=scene-rooftop&orientation=landscape',
    desc: '在城市的边缘，两人第一次说出不像台词的真心话，暧昧与算计在这一刻短暂停火。',
  },
  {
    title: '宴会揭穿',
    ep: '第 10 集',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20elegant%20banquet%20hall%20interior%20with%20chandeliers%20and%20guests%2C%20tense%20moment%20of%20a%20public%20confrontation%2C%20deep%20crimson%20and%20gold%20warm%20lighting%2C%20glamorous%20dark%20tone%2C%20film%20grain%2C%20short%20drama%20still&width=900&height=600&seq=scene-banquet&orientation=landscape',
    desc: '公开场合的一次揭穿让所有体面都失去意义，人物关系从此再无法回到原先的平衡。',
  },
  {
    title: '车站分别',
    ep: '第 15 集',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20train%20station%20platform%20at%20blue%20hour%20with%20soft%20golden%20platform%20lights%2C%20a%20lone%20traveler%20with%20a%20suitcase%20walking%20away%2C%20bittersweet%20emotional%20atmosphere%2C%20moody%20tones%2C%20film%20grain%2C%20short%20drama%20still&width=900&height=600&seq=scene-station&orientation=landscape',
    desc: '结局前的最后一次转身，没有人挽留也没有人回头，沉默给出了比台词更重的答案。',
  },
];

export const guideSteps = [
  { step: '01', title: '先看剧情梗概', desc: '用一两分钟了解主线走向与题材基调，判断它是否对你的胃口。' },
  { step: '02', title: '按标签挑选段落', desc: '在剧集列表选择「情感 / 悬疑 / 反转 / 高能 / 结局」，只看你偏爱的情绪节奏。' },
  { step: '03', title: '关注更新条', desc: '页面顶部更新条汇总最新上线的剧集区间，全集的推进状态一目了然。' },
  { step: '04', title: '配合名场面回味', desc: '看完高潮段落，可以到名场面分区对照关键镜头，理解人物当时的真实动机。' },
];

export const guideNotes = [
  '全集按编号顺序排列，从第 1 集开始连续浏览可获得最完整的情绪递进。',
  '若只想快速抓住主线，可优先看标记为「高能」与「反转」的剧集段落。',
  '页面内容为浏览索引，不提供播放与下载，具体内容请以实际发布版本为准。',
];

export const collections = [
  { title: '午夜回声', tag: '悬疑', desc: '深夜电台牵出的旧案，节奏冷静，靠信息差推进反转。', cover: 'https://readdy.ai/api/search-image?query=Moody%20cinematic%20poster%20of%20a%20lone%20microphone%20in%20a%20dark%20radio%20studio%20with%20crimson%20glow%2C%20mysterious%20atmosphere%2C%20film%20grain%2C%20minimal%20luxury%20short%20drama%20cover%20style%2C%20dark%20background&width=480&height=640&seq=rec-midnight-echo&orientation=portrait' },
  { title: '迷城的她', tag: '都市', desc: '在陌生城市重新开始的人，用一段关系换一次自我重建。', cover: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20young%20woman%20silhouette%20against%20a%20foggy%20city%20skyline%20at%20night%2C%20crimson%20and%20gold%20accents%2C%20melancholic%20mood%2C%20film%20grain%2C%20luxury%20short%20drama%20cover%20style%2C%20dark%20background&width=480&height=640&seq=rec-lost-city&orientation=portrait' },
  { title: '浮光之城', tag: '情感', desc: '光影交错的舞台背后，两段人生因为一次合作被迫靠近。', cover: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20bokeh%20city%20lights%20and%20soft%20warm%20gold%20tones%20with%20a%20blurred%20pair%20of%20figures%2C%20romantic%20dramatic%20mood%2C%20film%20grain%2C%20luxury%20short%20drama%20cover%20style%2C%20dark%20background&width=480&height=640&seq=rec-floating-light&orientation=portrait' },
  { title: '逆光而行', tag: '成长', desc: '在众人都劝她放弃时，她选择用结果回应所有的质疑。', cover: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20confident%20silhouette%20walking%20toward%20warm%20backlight%20in%20a%20dark%20corridor%2C%20gold%20rim%20light%2C%20empowering%20mood%2C%20film%20grain%2C%20luxury%20short%20drama%20cover%20style&width=480&height=640&seq=rec-against-light&orientation=portrait' },
  { title: '沉默契约', tag: '反转', desc: '一份不能对外公开的约定，把三个人绑在同一场赌局里。', cover: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20folded%20paper%20documents%20on%20a%20dark%20desk%20with%20a%20single%20warm%20lamp%2C%20tense%20mysterious%20mood%2C%20crimson%20and%20gold%20accents%2C%20film%20grain%2C%20luxury%20short%20drama%20cover%20style&width=480&height=640&seq=rec-silent-pact&orientation=portrait' },
  { title: '晚风知我意', tag: '情感', desc: '重新遇见旧人之后，她终于分清怀念和重新开始的区别。', cover: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20two%20figures%20under%20warm%20evening%20street%20lamps%20near%20a%20quiet%20alley%2C%20amber%20and%20crimson%20tones%2C%20tender%20nostalgic%20mood%2C%20film%20grain%2C%20luxury%20short%20drama%20cover%20style&width=480&height=640&seq=rec-evening-breeze&orientation=portrait' },
];

export const faqs = [
  {
    q: '《欲望的诱惑》一共有多少集？',
    a: '本站按 90 集的规模整理全集索引，剧集列表优先展示关键脉络段落，方便你快速把握整体结构；实际集数以正式发布为准。',
  },
  {
    q: '“全集免费看”指的是什么？',
    a: '页面提供的是剧集信息与浏览索引，帮助你了解每一集的看点与所处阶段，并不提供在线播放或下载资源。',
  },
  {
    q: '短剧大合集里的内容是什么？',
    a: '大合集收录了与本站题材相关的同类短剧条目，作为口味相近时的延伸浏览方向，点击章节可先看题材与风格说明。',
  },
  {
    q: '怎样快速找到我想看的剧情？',
    a: '先在剧集列表里按「情感 / 悬疑 / 反转 / 高能 / 结局」筛选，或在搜索框中输入关键词，例如“反转”“告白”，即可定位到对应段落。',
  },
  {
    q: '手机上浏览体验会不一样吗？',
    a: '页面针对移动端做了自适应，剧集列表、筛选标签与问答折叠在手机上同样可以顺畅阅读和操作。',
  },
];